// app/javascript/controllers/card_flip_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["card"]

    flip(event) {
        const flipLink = event.target.closest('.flip-link')
        if (!flipLink) return

        event.preventDefault()

        const card = flipLink.closest('.card')
        this.toggleFlip(card)
        flipLink.blur()
    }


    handleKeydown(event) {
        const active = event.target
        if (!active || !active.classList.contains('flip-link')) return

        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            const card = active.closest('.card')
            this.toggleFlip(card)
        }
    }

    toggleFlip(card) {
        if (!card) return

        const flipped = card.classList.toggle('is-flipped')
        card.querySelectorAll('.flip-link').forEach(link => {
            link.setAttribute('aria-pressed', String(flipped))
        })
    }
}